import { Clickable, Strong } from '@ahmdigital/ui';
import React from 'react';

import babyImage from './images/baby.svg';
import doctorImage from './images/doctor.svg';
import hospitalImage from './images/hospital.svg';
import pregnancyTestImage from './images/pregnancy-test.svg';

// @ts-expect-error - Automatic, Please fix when editing this file
const data = (onClickOutOfPocket) => ({
  headerSection: {
    advantages: {
      tiles: [
        {
          image: {
            alt: 'Hospital',
            src: hospitalImage.src,
          },
          summary: `Choose the private hospital where you give birth in a location that suits you and your obstetrician.`,
          title: 'Location, location, location',
        },
        {
          image: {
            alt: 'Doctor',
            src: doctorImage.src,
          },
          summary: 'Choose your obstetrician to care for you through pregnancy and birth.',
          title: 'Choice of doctor',
        },
        {
          image: {
            alt: 'Baby',
            src: babyImage.src,
          },
          summary: `You could get a private room for just you and your baby (subject to availability).`,
          title: 'More … privacy',
        },
      ],
      title: 'The advantages of going private',
    },
    description: (
      <div>
        Thinking about having a baby in a private hospital? We have hospital cover that pays towards services you
        receive in hospital during pregnancy and birth and helps you to enjoy the advantages of going private. To ensure
        you can use your health insurance for the birth of your baby, you just need to make sure you serve the{' '}
        <Strong>12-month</Strong> Waiting Period before your due date. It’s important to also be aware of any potential{' '}
        <Clickable onClick={onClickOutOfPocket}>out-of-pocket costs</Clickable>.
      </div>
    ),
    image: {
      alt: 'Pregnancy test',
      src: pregnancyTestImage.src,
    },
    title: 'Pregnancy and birth',
  },
  productSection: {
    subtitle: 'Hospital cover for pregnancy and birth and a few options for extras cover.',
    title: 'Some covers with benefits towards pregnancy and birth',
  },
});

export default data;
